import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CardWrapperComponent } from "../../../_shared/form/components/card-wrapper/card-wrapper.component";

@Component({
  selector: "app-local-storage-reset",
  standalone: true,
  imports: [CommonModule, CardWrapperComponent],
  templateUrl: "./local-storage-reset.component.html",
  styleUrls: ["./local-storage-reset.component.scss"],
})
export class LocalStorageResetComponent {
  steps: { id: string; label: string; status: "pending" | "in-progress" | "done" }[] = [
    { id: "scan", label: "Scannen van lokale data", status: "pending" },
    { id: "prepare", label: "Voorbereiden", status: "pending" },
    { id: "clear", label: "Verwijderen van lokale opslag", status: "pending" },
    { id: "finalize", label: "Afronden", status: "pending" },
  ];

  running = false;
  completed = false;

  constructor(protected router: Router) {}

  startReset(): void {
    if (this.running) return;
    this.running = true;
    this.completed = false;
    this.resetStatuses("pending");
    this.runSteps();
  }

  private async runSteps(): Promise<void> {
    for (const step of this.steps) {
      step.status = "in-progress";
      // small artificial delay to give user feedback
      await this.sleep(700 + Math.random() * 800);

      if (step.id === "clear") {
        // Clear localStorage without exposing its contents in the UI
        try {
          localStorage.clear();
        } catch (e) {
          // ignore errors (e.g. if running in some restricted test env)
        }
      } else if (step.id == "finalize") {
        setTimeout(() => {
          localStorage.removeItem("disableSigninModal");
          this.router.navigateByUrl("/");
        }, 2000);
      }

      // short pause to make each step visible
      step.status = "done";
      await this.sleep(300);
    }

    this.running = false;
    this.completed = true;
  }

  reset(): void {
    if (this.running) return;
    this.completed = false;
    this.resetStatuses("pending");
  }

  private resetStatuses(status: "pending" | "in-progress" | "done") {
    this.steps.forEach((s) => (s.status = status));
  }

  private sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
